import { ReactNode, useLayoutEffect } from 'react';
import { useMatch } from 'react-router';
import { useAppSelector } from '../hooks/store-hooks';
import { ROUTES } from '../router/routes';

export default function LightDarkProvider(props: { children?: ReactNode }) {
    const isDark = useAppSelector((x) => x.settings.isDark);
    const isLogin = useMatch(ROUTES.LOGIN);
    const isExternal = useMatch(ROUTES.REMOTE_LOGIN);
    const isCallback = useMatch(ROUTES.REMOTE_LOGIN_CALLBACK);
    const shouldBeDark = isLogin || isExternal || isCallback ? false : isDark;

    useLayoutEffect(() => {
        // If this is a child window the theme is managed by the host window
        if (window.opener) {
            return;
        }
        let theme = document.getElementById('theme') as HTMLLinkElement;
        if (!theme) {
            theme ??= document.createElement('link');
            theme.id = 'theme';
            theme.rel = 'stylesheet';
            document.head.appendChild(theme);
        }
        document.documentElement.dataset['isDark'] = shouldBeDark.toString();

        for (const frame of document.querySelectorAll('iframe[data-auto-sync-theme]')) {
            (frame as HTMLIFrameElement).contentWindow?.postMessage({ isDark: shouldBeDark }, '*');
        }
    }, [shouldBeDark]);

    return props.children;
}
